<template>
  <div class="row p-4">
    <div class="col-lg-12 mb-3">
      <h3>ENVIAR E-MAIL PARA OS(AS) CANDIDATOS(AS)</h3>
    </div>
    <div class="col-lg-6 mt-4">
      <table class="table_jovool mt-1">
        <thead class="headerTable">
          <tr>
            <td></td>
            <td>NOME</td>
            <td>EMAIL</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="candidate in candidates" :key="candidate.id">
            <td>
              <input
                type="checkbox"
                name="selectCandidate"
                :value="candidate.email"
                v-model="candidates_emails"
              />
            </td>
            <td>
              <span class="d-block">{{ candidate.name }}</span>
            </td>
            <td>
              <span class="d-block">{{ candidate.email }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-6">
      <div class="row">
        <div class="col-lg-12">
          <span class="ml-3 f14">ASSUNTO DO E-MAIL</span>
          <input type="text" v-model="subject" class="form-control mt-2" />
        </div>
        <div class="col-lg-12 mt-4">
          <span class="ml-3 f14">DESCRIÇÃO DO E-MAIL</span>
          <ckeditor v-model="description" class="mt-2" />
        </div>
        <div class="col-lg-12 mt-2 text-right">
          <button
            class="btn btn-primary w-50"
            @click="sendMail"
            :class="{ disabled: subject.length == 0 }"
          >
            ENVIAR EMAIL
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["candidates"],
  data: () => ({
    subject: "",
    description: "",
    candidates_emails: [],
  }),
  mounted() {
    this.candidates_emails = this.candidates.map(
      (candidate) => candidate.email
    );
  },
  methods: {
    sendMail() {
      if (this.subject.length == 0) {
        this.$toast.error("Por favor, preencha o assunto do e-mail.");
        return;
      }

      let mails = {
        subject: this.subject,
        description: this.description,
        candidates_emails: this.candidates_emails,
      };

      axios.post("/recruiters/send_mails", { mails }).then((response) => {
        if (response.data.status) {
          this.$toast.success("Email enviado com sucesso!");
          this.$emit("close");
          return;
        }

        this.$toast.error("Não foi possivel enviar o email");
      });
    },
  },
};
</script>